import { jsx } from 'react/jsx-runtime';

const SvgArrowBigDown = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "m11 16.86-6-5.04v2.62l7 5.86 7-5.86v-2.62l-6 5.04V4h-2v12.86Z" }) }));

export { SvgArrowBigDown as default };
//# sourceMappingURL=ArrowBigDown.es.js.map
